<template>
	<div>
		<div v-if="show==true" class="gray">
			<div class="dialog">
				<div style="display:inline-block; width:100%;">
					<p class="title">Edit Job Order {{joborderid}}</p>
					<p class="cancel" v-on:click="cancel()"><font-awesome-icon icon="times" /></p>
				</div>
				<hr/>
				<div class="scroll" style="max-height:50vh">
					<table style="position:relative; z-index:1">
						<tr v-for="(column, index) in add_names">
							<template
							v-if="add_names[index].substr(add_names[index].length-4) == 'Time'">
								<td>
									{{add_names[index]}}
								</td>
								<td>
									<datetime
									v-model="table_data[index]"
									style="width:100%"
									/>
								</td>
							</template>
							<template
							v-else-if="add_names[index] == 'JobType'">
								<td>
									{{add_names[index]}}
								</td>
								<td>
									<jobtype
									:index="index"
									:search="table_data[index]"
									:use_radio=use_radio
									:fixed=true
									v-on:input="setJobType"
									style="width:100%"
									>
									</jobtype>
								</td>
							</template>
							<template
							v-else-if="add_names[index] == 'Side'">
								<td>
									{{add_names[index]}}
								</td>
								<td>
									<autocomplete
									:list="['Starboard','Port']"
									v-model=table_data[index]
									:type="add_types[index]"
									:fixed=true
									style="width:100%"
									/>
								</td>
							</template>
							<template
							v-else-if="add_names[index].substr(0,1) == '_'">
								<td>
									{{add_names[index].substr(1,add_names[index].length-1)}}
								</td>
								<td>
									<input
									style="width:100%"
									v-model="table_data[index]"
									/>
								</td>
							</template>
							<template
							v-else>
								<td>
									{{add_names[index]}}
								</td>
								<td>
									<autocomplete
									v-model=table_data[index]
									:type="add_types[index]"
									:fixed=true
									style="width:100%"
									>
									</autocomplete>
								</td>
							</template>
						</tr>
					</table>
				</div>
				<hr/>
				<div style="display:inline-block; width:100%;">
					<button class="buttons" v-on:click="cancel()">Cancel</button>
					<button class="buttons" v-on:click="save()">Save</button>
				</div>
			</div>
		</div>
	</div>
</template>

<!--date, employee, port, side, customer, type, notes, comments, joborder comments-->

<script>
import api from '@/api'
import router from '@/router/index'
import {PAGES} from './../../constants.js'
import { nextTick } from 'vue';
export default {
    props: {
		joborderid: {
			type: Number
		},
		show: {
			type: Boolean,
			required:false,
			default:true,
		},
    },
	data() {
		return {
			pageid: PAGES.SCHEDULING_II_PAGE,

			add_names: [],
			add_types: [],
			table_data:[],
		}
	},
	async created () {

	},
	methods: {
		getTables () {
			this.add_names = []
			this.add_types = []
			this.table_data = []

			api.postData(
				{
					type:"add",
					data:{
						pageid:this.pageid,
						term:this.joborderid,
					}
				}
			).then((res) => {
				if(res.data.column_data)
					this.table_data = res.data.column_data;
				this.add_names = res.data.column_names;
				this.add_types = res.data.column_types;
			});
		},
		async save() {
			api.postData(
				{
					type:"insert",
					data:{
						pageid:this.pageid,
						term:this.joborderid,
						data:this.table_data,
					}
				}
			).then((res) => {
				if(res.data.errors!=undefined) {
					alert("error")
			    }else {
					this.$emit('save',this.table_data);
			    }
			}).finally(() => {
				this.cancel();
			});
		},
		async cancel() {
			this.$emit('cancel');
		},
	},
	watch:{
		show(){
			this.$nextTick(function () {
				if(this.show) {
					this.getTables()
				}
			})
		},
	}
}
</script>

<style scoped>

.dialog{
	position:fixed;
	background-color:white;
	left: 50%;
	top:20vh;
	min-width:500px;
	transform: translateX(-50%);
	padding:15px;
	border:1px solid black;
	border-radius: 5px;
	box-shadow: 2px 2px;
}

.title{
	font-size: 40px;
	font-weight: bold;
	float:left;
	margin:0px;
}

.cancel{
	float:right;
	width:30px;
	text-align: center;
	font-size:24px;
}
.cancel:hover{
	color:#5c5e70;
}

.paragraph{
	font-size:22px;
	margin:0px;
	white-space: pre-wrap;
}

.buttons{
	float:right;
	font-size:18px;
}

.gray {
	display: absolute;
	position: fixed;
	z-index: 2;
	padding-top: 100px;
	left: 0;
	top: 0;
	width:100%;
	height:100%;
	overflow:auto;
	background-color: rgba(0,0,0,0.5);
}

.textfield{
    width:100%;
	height:150px;
	min-height:75px;
	max-height:375px;
}

</style>



// WEBPACK FOOTER //
// src/layouts/schedule_dialog.vue